export const primary = "#319AFF";